import { render, staticRenderFns } from "./index_many_list.vue?vue&type=template&id=202d2aa8&scoped=true"
import script from "./index_many_list.vue?vue&type=script&lang=js"
export * from "./index_many_list.vue?vue&type=script&lang=js"
import style0 from "./index_many_list.vue?vue&type=style&index=0&id=202d2aa8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d2aa8",
  null
  
)

export default component.exports